<!-- <template>
  <section id="speakers" aria-labelledby="speakers-title" class="py-10">
    <svg aria-hidden="true" width="0" height="0">
      <defs>
        <clipPath id=":R57qfja:-0" clipPathUnits="objectBoundingBox">
          <path
            d="M0,0 h0.729 v0.129 h0.121 l-0.016,0.032 C0.815,0.198,0.843,0.243,0.885,0.243 H1 v0.757 H0.271 v-0.086 l-0.121,0.057 v-0.214 c0,-0.032,-0.026,-0.057,-0.057,-0.057 H0 V0">
          </path>
        </clipPath>
        <clipPath id=":R57qfja:-1" clipPathUnits="objectBoundingBox">
          <path
            d="M1,1 H0.271 v-0.129 H0.15 l0.016,-0.032 C0.185,0.802,0.157,0.757,0.115,0.757 H0 V0 h0.729 v0.086 l0.121,-0.057 v0.214 c0,0.032,0.026,0.057,0.057,0.057 h0.093 v0.7">
          </path>
        </clipPath>
        <clipPath id=":R57qfja:-2" clipPathUnits="objectBoundingBox">
          <path
            d="M1,0 H0.271 v0.129 H0.15 l0.016,0.032 C0.185,0.198,0.157,0.243,0.115,0.243 H0 v0.757 h0.729 v-0.086 l0.121,0.057 v-0.214 c0,-0.032,0.026,-0.057,0.057,-0.057 h0.093 V0">
          </path>
        </clipPath>
      </defs>
    </svg>
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <h2 id="speakers-title" class="font-display text-4xl font-bold tracking-tighter text-gray-900 sm:text-5xl">
        Areas to get involved!
      </h2>
      <p class="mt-4 font-display text-2xl tracking-tight text-gray-600">
        We are looking for a passionate group of volunteers to help us make this conference a success. If you would like
        to volunteer for this conference then please complete our online application form.
      </p>
      <div class="mt-10 grid grid-cols-1 items-start gap-x-8 gap-y-8 sm:mt-16 sm:gap-y-16 lg:grid-cols-4">

        <div class="lg:col-span-4">
          <div
            class="grid grid-cols-1 gap-x-8 gap-y-10 ui-not-focus-visible:outline-none sm:grid-cols-2 sm:gap-y-16 md:grid-cols-3">
            <div v-for="areaId in 16" :key="areaId">
              <div class="profile-img group relative transform overflow-hidden rounded-xl">
                <div class="absolute inset-0">
                  <img alt="" width="512" height="512"
                    class="absolute inset-0 h-full w-full object-cover transition duration-300 group-hover:scale-110"
                    :src="'/img/volunteer/areas-' + (areaId+1).toString() + '.jpg'">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
// window.location.href = 'https://prayerstorm.churchsuite.com/forms/7d8eezug'
</script>

<style scoped>
.card-zoom {
  @apply relative flex items-center justify-center overflow-hidden shadow-xl w-full;
  padding-bottom: 56.25%; /* 16:9 */
}
.card-zoom-image {
  @apply absolute inset-0 transition-all duration-500 ease-in-out transform bg-center bg-cover;
}
.card-zoom-text {
  @apply absolute inset-0 text-3xl font-black transition-all duration-500 ease-in-out transform scale-110 text-gray-50;
}
.card-zoom:hover .card-zoom-image {
  @apply scale-110;
}
.card-zoom:hover .card-zoom-text {
  @apply scale-100;
}

.profile-img {
  padding-bottom: 100%; /* 16:9 */
}
</style> -->

<template>
  <section id="volunteer" aria-labelledby="volunteer-title" class="py-10">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <h2 id="volunteer-title" class="font-display text-4xl font-bold tracking-tighter text-gray-900 sm:text-5xl">
        Volunteer with Prayer Storm
      </h2>
      <p class="mt-4 font-display text-2xl tracking-tight text-gray-600">
        Join a passionate team and help make a difference. Explore the areas you can serve in and click to apply!
      </p>
      <div class="mt-10 grid grid-cols-1 items-start gap-x-8 gap-y-10 sm:mt-16 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">

        <div
          v-for="(area, index) in 17"
          :key="index"
          @click="goToForm()"
          class="cursor-pointer group relative overflow-hidden rounded-xl shadow-lg transition transform hover:scale-105"
        >
          <img
            :src="`https://pslive.blob.core.windows.net/images/volunteer/areas-${index + 1}.jpg`"
            alt=""
            class="h-64 w-full object-cover"
          />
          <!-- <div
            class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center"
          >
            <h3 class="text-white text-xl font-semibold group-hover:underline text-center px-4">
              {{ area }}
            </h3>
          </div> -->
        </div>

      </div>
    </div>
  </section>
</template>

<script setup>
const applicationUrl = 'https://prayerstorm.churchsuite.com/forms/7d8eezug'

const goToForm = () => {
  window.open(applicationUrl, '_blank')
}
</script>

<style scoped>
/* Optional: Add any extra custom styling here */
</style>
